import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Skills from '../components/Skills';
import Projects from '../components/Projects';
import Music from '../components/Music';
import Experience from '../components/Experience';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-slate-950 relative">
      <Navbar />
      <Hero />
      <About />
      <Skills />
      <Projects />
      <Music />
      {/* <Experience /> */}
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;